
function NotFound() {
    return <div className="NotFound">
      <h1 className="text-3xl font-bold underline">
          Page does not exists
      </h1>
    </div>;
  }
  
  export default NotFound;
  